export default "<h1>Grey 中性色</h1>\n<p>中性色是一个不变的辅助色, 横向扩展的配色方案.</p>\n"